export default {
  // 搜索区域
  searchPlaceholder: '请输入模型名称',
  searchButton: '查询',
  addModel: '新增模型',

  // 弹窗标题
  editModelTitle: '修改模型',
  uploadModelTitle: '上传模型',

  // 表单字段
  modelNameField: '模型名称',
  modelNamePlaceholder: '请输入模型名称',
  modelLabelField: '模型标签',
  modelLabelPlaceholder: '请选择模型标签',
  modelTypeField: '模型类型',
  modelTypePlaceholder: '请选择模型类型',
  largeModel: '大模型',
  smallModel: '小模型',
  versionField: '版本号',
  versionPlaceholder: '请输入版本号，如：1.0',
  statusField: '状态',
  statusPlaceholder: '请选择状态',
  normal: '正常',
  stopped: '停用',
  modelFileField: '模型文件',
  selectModelFile: '选择模型文件',

  // 表格列
  modelName: '模型名称',
  versionNumber: '版本号',
  recentTrainingTime: '最近训练时间',
  onlineTime: '上线时间',
  modelStatus: '模型状态',
  modelLabel: '模型标签',
  deployStatus: '部署状态',
  createTime: '创建时间',
  operation: '操作',

  // 状态值
  running: '运行中',
  alreadyStopped: '已停止',
  separator: '---',

  // 操作按钮
  deleteModel: '删除模型',
  deleteContainer: '删除容器',
  stopContainer: '停止容器',
  deploy: '部署',
  edit: '修改',

  // 按钮
  cancel: '取消',
  confirm: '确定',

  // 校验提示
  modelNameRequired: '请输入模型名称',
  modelLabelRequired: '请选择模型标签',
  versionRequired: '请输入版本号',
  modelTypeRequired: '请选择模型类型',
  statusRequired: '请选择状态',
  selectModelFileRequired: '请选择模型文件',

  // 提示消息
  modelUpdateSuccess: '模型修改成功',
  modelUploadSuccess: '模型上传成功',
  deploySuccess: '部署成功',
  deployFailed: '部署失败',
  containerDeleteSuccess: '容器删除成功',
  containerDeleteFailed: '容器删除失败',
  deleteSuccess: '删除成功',
  deleteFailed: '删除失败',
  containerStopSuccess: '容器停止成功',
  containerStopFailed: '容器停止失败',
  uploadFailed: '上传失败',
  updateFailed: '修改失败',

  // 确认对话框
  confirmDeployTitle: '确认部署',
  confirmDeployContent: '确定要部署模型{name}吗？',
  confirmDeleteContainerTitle: '确认删除容器',
  confirmDeleteContainerContent: '确定要删除模型「{name}」的容器吗？',
  confirmDeleteModelTitle: '确认删除模型',
  confirmDeleteModelContent: '确定要删除模型{name}吗？',
  confirmStopContainerTitle: '确认停止容器',
  confirmStopContainerContent: '确定要停止模型「{name}」的容器吗？',
}
